import React, { useMemo } from 'react'

import Modal from 'LuxKit/Modal/Modal'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'

import AccommodationAmenitiesAndPoliciesContent from './AccommodationAmenitiesAndPoliciesContent'
import AccommodationRoomDetailsList from './AccommodationRoomDetailsList'
import { mapRoomPackage } from './roomPackageUtils'

interface Props {
  roomPackage: App.Property.Room | App.HotelPackage | App.BedbankPackage
}

function AccommodationAmenitiesAndPoliciesModal(props: Props) {
  const { roomPackage } = props
  const packageName = useMemo<string>(() => {
    return mapRoomPackage(
      roomPackage,
      ({ name }) => name,
      ({ roomType: { name } }) => name,
      ({ name }) => name,
    )
  }, [roomPackage])

  return <Modal
    title="Room amenities & policies"
    subtitle={packageName}
  >
    <Group direction="vertical" gap={20}>
      <Group direction="vertical" gap={12}>
        <Heading variant="heading6">Room Details</Heading>
        <AccommodationRoomDetailsList roomPackage={roomPackage} />
      </Group>
      <AccommodationAmenitiesAndPoliciesContent roomPackage={roomPackage} />
    </Group>
  </Modal>
}

export default AccommodationAmenitiesAndPoliciesModal
